import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import ProfileFieldInput from './ProfileFieldInput';
import { getProfileFieldGridSize } from './constants';
import { getProfileFieldRowState } from './profileFieldGridHelpers';

/**
 * Renders product profile fields for purchase flows (keyed by profile_field_id).
 */
const ProductProfileFieldsGrid = ({
  profileFields,
  formValues,
  formSubmitted,
  onChange,
  fieldErrors,
}) => {
  if (!profileFields?.length) {
    return null;
  }

  return profileFields.map((group, groupIndex) =>
    group?.profile_fields?.map((field, fieldIndex) => {
      const fieldId = field.profile_field_id;
      const { displayValue, helperText, hasError } = getProfileFieldRowState(
        field,
        formValues[fieldId],
        formSubmitted,
        fieldErrors,
        fieldId,
      );

      return (
        <Grid
          size={getProfileFieldGridSize(field)}
          key={`${groupIndex}-${fieldId ?? fieldIndex}`}
        >
          <ProfileFieldInput
            field={field}
            value={displayValue}
            onChange={onChange}
            error={hasError}
            helperText={helperText}
          />
        </Grid>
      );
    }),
  );
};

ProductProfileFieldsGrid.propTypes = {
  profileFields: PropTypes.array,
  formValues: PropTypes.object,
  formSubmitted: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  fieldErrors: PropTypes.object,
};

export default ProductProfileFieldsGrid;
